<script>
    export let product;
    export let reference;

    const productCardClasses = "pl-0.5 pb-0.5 items-center";
    const featuredProductCardClasses = "p-1 items-start";
</script>

<!-- Colours come as 'Matt Blk/Red', so for tailwind classes need to be formatted to 'matt-blk-red' -->

<div class="absolute flex bottom-0 left-0 gap-[2px] justify-start {reference === "FeaturedProductCard" ? featuredProductCardClasses : productCardClasses}">
    {#each product.optionsWithUniqueValues['Colour'] as colour, index}
        {#if index <= 3}
            <div class="h-1.5 w-1.5 rounded-full border-slate-700 border bg-swatch-{colour.toLowerCase().replaceAll(" ", "-").replaceAll("/", "-")}"></div>
        {/if}
    {/each}
    {#if product.optionsWithUniqueValues['Colour'].length >= 5}
        <p class="ml-[4px] text-b5">+ {product.optionsWithUniqueValues['Colour'].length - 4}</p>
    {/if}
</div>